<div mat-dialog-title>
  <div class="container-fluid">
    <div class="row g-0">
      <div class="col-auto g-0 my-auto me-3">
        <button class="btn-small" matMiniFab aria-label="Reset Filters" (click)="clearAll()" matTooltip="Clear all code filters">
          <mat-icon>autorenew</mat-icon>
        </button>
      </div>
      <div class="col g-0 my-auto text-center me-3">Project Code Filter</div>
      <div class="col-auto g-0 my-auto me-3">
        <mat-button-toggle-group [formControl]="data.codesMode">
          <mat-button-toggle value="AND">And</mat-button-toggle>
          <mat-button-toggle value="OR">Or</mat-button-toggle>
        </mat-button-toggle-group>
      </div>
      <div class="col-auto g-0 my-auto">
        <mat-form-field>
          <mat-label>Search</mat-label>
          <button matPrefix matIconButton aria-label="Clear search" (click)="searchFilter.reset(); loadCodes();">
            <mat-icon>clear</mat-icon>
          </button>
          <input matInput [formControl]="searchFilter" type="text" (change)="loadCodes()" class="w-100">
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
      </div>
    </div>
  </div>
</div>
<div mat-dialog-content class="py-3 scrollbar">
  <mat-accordion class="list-headers dense-1">
    @for (type of codeTypes; track $index) {
      @if (codeMap.get(type.proj_catg_type_id)?.length) {
        <mat-expansion-panel hideToggle>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-checkbox (click)="$event.stopPropagation();"
                [checked]="type.complete"
                [indeterminate]="type.partial"
                (change)="updateType(type, $event.checked);"
              ></mat-checkbox>
              {{ type.proj_catg_type }} <span class="text-muted">&nbsp;- {{ type.total_assignments | number:'1.0-0'}} projects assigned</span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <div class="row">
              @for (code of codeMap.get(type.proj_catg_type_id); track $index) {
                <div class="col-12 col-md-6 col-lg-4 col-xl-3">
                  <mat-checkbox
                    [checked]="code.checked"
                    (change)="updateCode(code, $event.checked)"
                  >{{ code.proj_catg_name }} ({{ code.proj_catg_short_name }})<span class="text-muted"> - {{ code.total_assignments ? code.total_assignments : 0 | number:'1.0-0' }} </span></mat-checkbox>
                </div>
              }
            </div>
          </ng-template>
        </mat-expansion-panel>
      }
    }
  </mat-accordion>
</div>
<div mat-dialog-actions>
  <button matButton="filled" (click)="close()">Apply</button>
</div>